module.exports = __webpack_public_path__ + "static/home-feature-3-v3-ee0d67b4fac9239585ed270c6efb7fa1.svg";